import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './FailureDialog.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import crossIconRed from '../../../assets/icons/icon-dialog-cross-red.png';

const failureDialog = (props) => {
    return(
        <FlexModal visible={props.show}>
            <div className={classes.FailureDialog}>
                <img 
                    className={classes.CloseIcon}
                    src={closeIconBlack}
                    alt="Close Icon"
                    onClick={props.buttonClicked}
                />
                <img
                    className={classes.RedCross}
                    alt="Tick Icon"
                    src={crossIconRed} />
                <h3 className={classes.FailedText}>Failed</h3>
                <h4 className={classes.FailedsMessage}>{props.message}</h4>

                <div className={classes.ActionButton}>
                    <Button 
                        styleclass="NonMobileOnly"
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="8px 48px"
                    />
                    <Button 
                        width="6em"
                        fontSize="0.625em"
                        styleclass="MobileOnly"
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="1em 2em"
                    />
                </div>
            </div>
        </FlexModal>
    );
}

export default failureDialog;